const KNOWN_ENRICHMENT_METHODS = new Set(['direct_apify', 'web_search']);

export function enrichmentMethodLabelKey(method: string): string {
  return `leads.enrichment.method.${KNOWN_ENRICHMENT_METHODS.has(method) ? method : 'other'}`;
}
